// Updated src/pages/UsersPage.js
import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { PlusCircle } from 'lucide-react';
import axios from 'axios';
import { apiUrl } from '../../config/Config';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import CreateUserModal from '../../components/modals/CreateUserModal';
import UpdateUserModal from '../../components/modals/UpdateUsers';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

const User = () => {
  const userdata = useSelector((store) => store.userReducer.userdata);
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [showUpdateUserModal, setShowUpdateUserModal] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState({});
  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState();
  const [showLoading, setShowLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const defaultColDef = useMemo(() => ({ flex: 1 }), []);

  const handleCheckboxChange = async (t, id) => {
    setShowLoading(true);
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + userdata?.token,
      },
    };
    const data = { id, status: t.target.checked ? 'true' : 'false' };

    try {
      const res = await axios.post(apiUrl + 'updateinternaluserstatus', data, headers);
      if (res.data.status === 'success') {
        fetchUsers();
      } else if (res.data.message === 'invalid user') {
        dispatch({ type: 'userdata', payload: {} });
        navigate('/login');
      } else {
        Swal.fire({
          text: res.data.message,
          icon: 'error',
          width: '350px',
          confirmButtonText: 'Ok',
          confirmButtonColor: 'rgb(59, 151, 196)',
          customClass: { popup: 'small-icon-alert' },
        });
      }
    } catch (err) {
      alert(err.message);
    } finally {
      setShowLoading(false);
    }
  };

  const fetchUsers = async () => {
    setShowLoading(true);
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + userdata?.token,
      },
    };

    try {
      const res = await axios.get(apiUrl + 'getallaccounts', headers);
      if (res.data.status === 'success') {
        const prevdata = res?.data?.data;
        if (prevdata?.length > 0) {
          const columnsarr = [];
          const hidecolumns = ['userid', 'updated_at', 'created_at', 'status'];
          const hidefilters = [];
          const columns = Object.keys(prevdata[0]);

          for (let i = 0; i < columns.length; i++) {
            if (!hidecolumns.includes(columns[i])) {
              const obj = {
                field: columns[i],
                cellStyle: { color: '#000', fontWeight: 600 },
              };
              if (!hidefilters.includes(columns[i])) {
                obj.cellClass = 'inventorycell';
                obj.filter = true;
                obj.filterParams = {
                  filterOptions: ['contains'],
                  maxNumConditions: 1,
                };
              }
              columnsarr.push(obj);
            }
          }
 //Status


//  var statusobj = {
//   field: "status",
//   headerName: "Status",
//   cellRenderer: (props) => {
//     // console.log('props >>', props?.data)
//     return (
//       <div className="d-flex">
//         <div class="form-check">
//           <input
//           onChange={(t) => {handleCheckboxChange(t, props?.data?.userid)}}
//             type="checkbox"
//             class="form-check-input tableformcheck"
//             id="check1"
//             name="option1"
//             value="something"
//             checked={props?.data?.status == 'true' || props?.data?.status == true ? true : false}
//           />
//         </div>
//       </div>
//     );
//   },
// };
// columnsarr.push(statusobj);











          columnsarr.push({
            field: 'status',
            headerName: 'Status',
            cellRenderer: (props) => (
              <input
                type="checkbox"
                      class="form-check-input tableformcheck"
                checked={props?.data?.status === 'true' || props?.data?.status === true}
                onChange={(t) => handleCheckboxChange(t, props?.data?.userid)}
              />
            ),
          });
 //action
          columnsarr.push({
            field: 'action',
            headerName: 'Action',
            cellRenderer: (props) => (
              <FontAwesomeIcon
                icon={faPenToSquare}
                className="sidebaricons"
                style={{ color: 'blue', cursor: 'pointer' }}
                onClick={() => {
                  setSelectedUserData(props?.data);
                  setShowUpdateUserModal(true);
                }}
              />
            ),
          });

          setColDefs(columnsarr);
          setRowData(prevdata);
        }
      } else if (res.data.message === 'invalid user') {
        dispatch({ type: 'userdata', payload: {} });
        navigate('/login');
      } else {
        Swal.fire({
          text: res.data.message,
          icon: 'error',
          width: '350px',
          confirmButtonText: 'Ok',
          confirmButtonColor: 'rgb(59, 151, 196)',
          customClass: { popup: 'small-icon-alert' },
        });
      }
    } catch (err) {
      alert(err.message);
    } finally {
      setShowLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleSaveUser = () => {
    setShowCreateUserModal(false);
    fetchUsers();
  };

  const handleUpdateUser = () => {
    setShowUpdateUserModal(false);
    fetchUsers();
  };

  return (
    <section className="users-section" style={{ padding: '20px' }}>
      {/* <h3 className="section-title" style={{ marginBottom: '15px' }}>Team Members</h3> */}
      <div className='posts-header'>  <button
        onClick={() => setShowCreateUserModal(true)}
        className="primary-button icon-left"
        style={{ marginTop: '0px' }}
      >
        <PlusCircle size={18} /> Add Internal User
      </button></div>
    
      <div className="ag-theme-quartz" style={{ height: 400, width: '100%' }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          pagination={true}
          paginationPageSize={10}
          rowHeight={50}
        />
      </div>



      <CreateUserModal
        isOpen={showCreateUserModal}
        onClose={() => setShowCreateUserModal(false)}
        onSave={handleSaveUser}
      />

      <UpdateUserModal
        isOpen={showUpdateUserModal}
        onClose={() => setShowUpdateUserModal(false)}
        userdata={selectedUserData}
        onSave={handleUpdateUser}
      />
    </section>
  );
};

export default User;
